"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyLabels = exports.Currency = exports.Currencies = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.Currencies = ['usd', 'cad', 'mxn'];
/* @deprecated Use Invoice.CurrencyCode instead for types */
exports.Currency = typebox_1.Type.Union(exports.Currencies.map((c) => typebox_1.Type.Literal(c)));
exports.CurrencyLabels = {
    usd: 'USD',
    cad: 'CAD',
    mxn: 'MXN',
};
//# sourceMappingURL=currency.js.map